<script setup lang="ts">
/**
 * Visually hidden polite live region of the charts: announces the category
 * (or cell) the keyboard just moved to, with its values — the spoken form of
 * the hover tooltip, which is hidden from assistive technology.
 */
defineProps<{ text: string }>();
</script>

<template>
  <span class="nx-chart-live" aria-live="polite" aria-atomic="true">{{ text }}</span>
</template>

<style scoped>
.nx-chart-live {
  position: absolute;
  width: var(--nxt-hairline);
  height: var(--nxt-hairline);
  margin: calc(var(--nxt-hairline) * -1);
  overflow: hidden;
  clip-path: inset(50%);
  white-space: nowrap;
}
</style>
